module.exports = __webpack_public_path__ + "static/media/ifps.a111fafe.jpg";